import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers';

const contactInformation = Loadable(() => isFuncComp() ? import('../../FuncContainers/contactInformation') : import('../../containers/web/contactInformation'));
export default MapTo('vcg/components/soe-home/react/contactInformation')(contactInformation);
